import axios from 'axios';
import { createSignedGetRequest, createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const getNotificationEmails = async () => {
    const signedRequest = await createSignedGetRequest({
        apiPath: 'legacy_admin/renolog/notification-emails',
        isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
    });
    const response = await axios(signedRequest);
    return response.data;
};

export const updateNotificationEmails = async (emails) => {
    const signedRequest = await createSignedPatchRequest({
        apiPath: 'legacy_admin/renolog/notification-emails',
        isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
        body: { notificationEmails: emails },
    });
    const response = await axios(signedRequest);
    return response.data;
};
